<form [formGroup]="form | bgoAsFormGroup" *transloco="let t">
  <h2 class="mb-md heading-md">{{ t('createJobRequest.treeCutting.title') }}</h2>
  <cft-number-input
    [formControl]="form.controls.upTo4MetersCount | bgoAsFormControl"
    [min]="0"
    [max]="200"
    [step]="1"
    [hasWarning]="form.controls.upTo4MetersCount.invalid && form.controls.upTo4MetersCount.touched"
    [label]="t('createJobRequest.treeCutting.utTo4Meters.label')"
    class="block"
  />
  @if (form.controls.upTo4MetersCount.touched && form.controls.upTo4MetersCount.invalid) {
    <div class="mb-md error">
      {{ t('createJobRequest.treeCutting.error') }}
    </div>
  }

  <cft-number-input
    [formControl]="form.controls.from4To6MetersCount | bgoAsFormControl"
    [min]="0"
    [max]="200"
    [step]="1"
    [hasWarning]="form.controls.from4To6MetersCount.invalid && form.controls.from4To6MetersCount.touched"
    [label]="t('createJobRequest.treeCutting.from4To6Meters.label')"
    class="block"
  />
  @if (form.controls.from4To6MetersCount.touched && form.controls.from4To6MetersCount.invalid) {
    <div class="error">
      {{ t('createJobRequest.treeCutting.error') }}
    </div>
  }
</form>
